import { useState } from 'react';
import { motion } from 'framer-motion';
import { ESSAYS } from './data';

// FIELD NOTES — newspaper second-page essay archive. Vertical list with byline & dropcap.
export default function Notes({ setPage }) {
  const cats = ['All', ...new Set(ESSAYS.map(e => e.cat))];
  const [c, setC] = useState('All');
  const list = c === 'All' ? ESSAYS : ESSAYS.filter(e => e.cat === c);
  return (
    <div className="bg-[#F4EEE0] text-[#1A1410] min-h-screen">
      <section className="pt-32 pb-8 max-w-[1500px] mx-auto px-8 lg:px-14 border-b-[3px] border-[#1A1410]">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#7B1A1A] mb-3">— § II / Field Notes — six issues, in order of arrival</p>
        <h1 className="font-serif italic text-[44px] lg:text-[88px] leading-[0.95]">A monthly correspondence.</h1>
      </section>

      <div className="border-b border-[#1A1410]/15 sticky top-20 bg-[#F4EEE0]/95 backdrop-blur-md z-30">
        <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-4 flex flex-wrap gap-2 font-mono text-[10px] tracking-[0.22em] uppercase">
          {cats.map(cat => (
            <button key={cat} onClick={() => setC(cat)} data-testid={`mv-cat-${cat}`} className={`px-3 py-1.5 transition-colors ${c === cat ? 'bg-[#7B1A1A] text-[#F4EEE0]' : 'border border-[#1A1410]/25 text-[#1A1410]/65 hover:border-[#7B1A1A]'}`}>{cat}</button>
          ))}
        </div>
      </div>

      <section className="max-w-[1100px] mx-auto px-8 lg:px-14 py-12 divide-y divide-[#1A1410]/20">
        {list.map((e, i) => (
          <motion.article key={e.iss} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.05 }} className="grid md:grid-cols-[120px_1fr_auto] gap-6 py-9 items-baseline">
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#7B1A1A]">
              <p>No. {e.iss}</p>
              <p className="text-[#1A1410]/50 mt-1">{e.date}</p>
              <p className="text-[#1A1410]/50 mt-1">{e.read}</p>
            </div>
            <div>
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#1A1410]/45 mb-2">— {e.cat}</p>
              <h2 className="font-serif italic text-3xl lg:text-5xl leading-[0.98] hover:text-[#7B1A1A] cursor-pointer transition-colors">{e.t}</h2>
              <p className="font-serif text-base text-[#1A1410]/70 mt-4 leading-[1.7] max-w-2xl">{e.d}</p>
            </div>
            <button onClick={() => setPage('apply')} className="font-mono text-[10px] tracking-[0.32em] uppercase border border-[#1A1410]/40 text-[#1A1410] px-4 py-2.5 hover:bg-[#7B1A1A] hover:text-[#F4EEE0] hover:border-[#7B1A1A] transition-colors whitespace-nowrap" data-testid={`mv-essay-${e.iss}`}>Read · {e.read} →</button>
          </motion.article>
        ))}
      </section>
    </div>
  );
}
